import styled from 'styled-components';

export const PillListContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
`